export default "__VITE_ASSET__CN7j3dyC__"